import { useTranslation } from "@flare/i18n";
import { Text } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

import { useFunnelExperimentContext } from "../funnel-experiment-context";

export function Footer({ className }: { className?: string }) {
  const { t } = useTranslation();

  const funnelExperimentContext = useFunnelExperimentContext();

  return (
    <footer
      className={cn(
        "border-t border-primary bg-surface md:h-auto",
        {
          "h-[208px] md:h-auto":
            !funnelExperimentContext.showNewQuestionsAndButtons(),
        },
        className,
      )}
    >
      <div className="m-auto max-w-[1054px] ">
        <Text variant="caption" className="p-sp-5">
          {t("FUNNEL_FOOTER_DISCLAIMER_TEXT")}
        </Text>
      </div>
    </footer>
  );
}
